"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var ITEM_CLICK = {
  EXPAND: 'expand',
  LINK: 'link',
  NOTHING: 'nothing',
  FULLSCREEN: 'fullscreen'
};
var _default = ITEM_CLICK;
exports["default"] = _default;